import '@babel/polyfill';
import '@/scss/app.scss'

if (module.hot) {
  module.hot.accept()
}
